import wootConstants from 'dashboard/constants/globals';

export default {
  methods: {
    setFilterAttributess() {
      const allFilterGroups = this.actionAttributeGroups.map(group => {
        return {
          name: this.$t(`${this.filtersFori18n}.GROUPS.${group.i18nGroup}`),
          attributes: group.attributes.map(attribute => {
            return {
              key: attribute.key,
              name: this.$t(
                `${this.filtersFori18n}.ATTRIBUTES.${attribute.i18nKey}`
              ),
            };
          }),
        };
      });
      this.actionGroup = [...allFilterGroups];
    },

    // initializeExistingFilterToModal() {
    //   this.initializeStatusAndAssigneeFilterToModal();
    //   this.initializeInboxTeamAndLabelFilterToModal();
    // },
    // initializeStatusAndAssigneeFilterToModal() {
    //   if (this.activeStatus !== '') {
    //     this.appliedActions.push({
    //       attribute_key: 'status',
    //       attribute_model: 'standard',
    //       filter_operator: 'equal_to',
    //       values: [
    //         {
    //           id: this.activeStatus,
    //           name: this.$t(
    //             `CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${this.activeStatus}.TEXT`
    //           ),
    //         },
    //       ],
    //       query_operator: 'and',
    //       custom_attribute_type: '',
    //     });
    //   }
    //   if (this.activeAssigneeTab === wootConstants.ASSIGNEE_TYPE.ME) {
    //     this.appliedFilter.push({
    //       attribute_key: 'assignee_id',
    //       filter_operator: 'equal_to',
    //       values: this.currentUserDetails,
    //       query_operator: 'and',
    //       custom_attribute_type: '',
    //     });
    //   }
    // },
    // initializeInboxTeamAndLabelFilterToModal() {
    //   if (this.conversationInbox) {
    //     this.appliedActions.push({
    //       attribute_key: 'inbox_id',
    //       attribute_model: 'standard',
    //       filter_operator: 'equal_to',
    //       values: [
    //         {
    //           id: this.conversationInbox,
    //           name: this.inbox.name,
    //         },
    //       ],
    //       query_operator: 'and',
    //       custom_attribute_type: '',
    //     });
    //   }
    //   if (this.teamId) {
    //     this.appliedActions.push({
    //       attribute_key: 'team_id',
    //       attribute_model: 'standard',
    //       filter_operator: 'equal_to',
    //       values: this.activeTeam,
    //       query_operator: 'and',
    //       custom_attribute_type: '',
    //     });
    //   }
    //   if (this.label) {
    //     this.appliedActions.push({
    //       attribute_key: 'labels',
    //       attribute_model: 'standard',
    //       filter_operator: 'equal_to',
    //       values: [
    //         {
    //           id: this.label,
    //           name: this.label,
    //         },
    //       ],
    //       query_operator: 'and',
    //       custom_attribute_type: '',
    //     });
    //   }
    // },
  },
};
